import React from 'react';
import { Description } from './Description';

const ListItem = props => {
  const { children } = props;
  return (
    <div className='InsuranceDocumentAttention__list-item'>{children}</div>
  );
};

export const InsuranceDocumentMyNumberCardWarning = () => (
  <Description type='warning'>
    <div className='InsuranceDocumentAttention'>
      <div className='InsuranceDocumentAttention__description'>
        以下の情報は黒塗り（マスキング）して添付して頂きますようお願いします。
        <br />
        黒塗り（マスキング）がない場合は、リバスタにてマスキングを行う場合がございます。
      </div>
      <br />
      <div className='InsuranceDocumentAttention__list'>
        <div className='InsuranceDocumentAttention__list-block'>
          <ListItem>・他者の個人情報</ListItem>
          <ListItem>・住民票コード</ListItem>
        </div>
        <div className='InsuranceDocumentAttention__list-block'>
          <ListItem>・被保険者等記号・番号</ListItem>
          <ListItem>・保険者番号</ListItem>
        </div>
        <div className='InsuranceDocumentAttention__list-block'>
          <ListItem>・QRコード</ListItem>
          <ListItem>・基礎年金番号</ListItem>
        </div>
      </div>
      <br />
      <ul className='InsuranceDocumentAttention--warning bold'>
        ※本サービスにマイナンバーカード（表面・裏面）を登録しないでください。
        <li className='InsuranceDocumentAttention--warning__item'>
          マイナンバーカードの保有者本人であっても、法令に定める場合を除き、マイナンバー情報を提供することはできません。（番号法第19条）
        </li>
        <li className='InsuranceDocumentAttention--warning__item'>
          万が一、マイナンバーカードの登録が発見された場合は、リバスタにて登録データの削除をする場合がございます。
        </li>
      </ul>
    </div>
  </Description>
);



// WEBPACK FOOTER //
// ./src/components/InsuranceDocumentAttention.jsx